class ProductNavigation extends HTMLElement {
    constructor() {
      super();
    }
  
    intersectionObserverCallback(entries, observer) {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          this.classList.remove('active');
        } else {
          this.classList.add('active');
          this.classList.remove('nav-hidden');
        }
      });
    }

    handleTransitionEnd(event) {
        if (event.propertyName == "opacity") {
          if (!this.classList.contains('active')) {
            this.classList.add('nav-hidden')
          }
        }
    }

    connectedCallback() {
        const intersectionObserver = new IntersectionObserver(this.intersectionObserverCallback.bind(this));
    
        this.productInfoEl = document.querySelector('product-info[id^="MainProduct-"]');
        intersectionObserver.observe(this.productInfoEl);

        this.addEventListener("transitionend", this.handleTransitionEnd.bind(this));
    }

    disconnectedCallback() {
        intersectionObserver.disconnect();
        this.removeEventListener("transitionend", this.handleTransitionEnd.bind(this));
    }
  }
  
  customElements.define('product-navigation', ProductNavigation);
  